import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]

  connect() {
    const linkedPanel = this.panelTargets.find((panel) => `#${panel.id}` === window.location.hash)
    const selected = this.tabTargets.find((tab) => tab.getAttribute("aria-selected") === "true")
    this.show(linkedPanel?.dataset.showcaseKey || selected?.dataset.showcaseKey || this.tabTargets[0]?.dataset.showcaseKey)

    if (linkedPanel) {
      requestAnimationFrame(() => linkedPanel.scrollIntoView({ block: "start" }))
    }
  }

  select(event) {
    this.show(event.currentTarget.dataset.showcaseKey)
  }

  navigate(event) {
    if (!["ArrowLeft", "ArrowRight", "Home", "End"].includes(event.key)) return

    event.preventDefault()
    const currentIndex = this.tabTargets.indexOf(event.currentTarget)
    let nextIndex

    if (event.key === "Home") nextIndex = 0
    else if (event.key === "End") nextIndex = this.tabTargets.length - 1
    else {
      const direction = event.key === "ArrowRight" ? 1 : -1
      nextIndex = (currentIndex + direction + this.tabTargets.length) % this.tabTargets.length
    }

    const nextTab = this.tabTargets[nextIndex]
    this.show(nextTab.dataset.showcaseKey)
    nextTab.focus()
  }

  show(key) {
    if (!key) return

    this.tabTargets.forEach((tab) => {
      const selected = tab.dataset.showcaseKey === key
      tab.setAttribute("aria-selected", selected.toString())
      tab.tabIndex = selected ? 0 : -1
      tab.classList.toggle("border-indigo-600", selected)
      tab.classList.toggle("text-indigo-700", selected)
      tab.classList.toggle("dark:border-indigo-400", selected)
      tab.classList.toggle("dark:text-indigo-300", selected)
      tab.classList.toggle("border-transparent", !selected)
      tab.classList.toggle("text-slate-500", !selected)
      tab.classList.toggle("dark:text-slate-400", !selected)
    })

    this.panelTargets.forEach((panel) => {
      const selected = panel.dataset.showcaseKey === key
      panel.hidden = !selected
      panel.classList.toggle("hidden", !selected)
    })
  }
}
